// extracted by mini-css-extract-plugin
export default {"contain":"EmojiPicker__contain___FquOY","button":"EmojiPicker__button____xT1u","popOver":"EmojiPicker__popOver___nUnQK","containdown":"EmojiPicker__containdown___PvR6p"};